/**
 * @generated SignedSource<<9c04bb44dfaefbc6809e55f572a75561>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CefrLevel = "A1" | "A2" | "B1" | "B2" | "C1" | "C2" | "PRE_A1" | "%future added value";
export type AccountProfileQuery$variables = Record<PropertyKey, never>;
export type AccountProfileQuery$data = {
  readonly me: {
    readonly email: string;
    readonly emailVerified: boolean;
    readonly learner: {
      readonly cefrLevel: CefrLevel;
      readonly displayName: string;
      readonly id: string;
      readonly memories: ReadonlyArray<{
        readonly createdAt: any;
        readonly id: string;
        readonly kind: string;
        readonly text: string;
      }>;
      readonly nativeLanguage: string | null | undefined;
      readonly picture: {
        readonly preset: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AccountProfileQuery = {
  response: AccountProfileQuery$data;
  variables: AccountProfileQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Account",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailVerified",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nativeLanguage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cefrLevel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnerPicture",
            "kind": "LinkedField",
            "name": "picture",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preset",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnerMemory",
            "kind": "LinkedField",
            "name": "memories",
            "plural": true,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountProfileQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountProfileQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "48845fa57c00bc52441107bb35d7dfa5",
    "id": null,
    "metadata": {},
    "name": "AccountProfileQuery",
    "operationKind": "query",
    "text": "query AccountProfileQuery {\n  me {\n    email\n    emailVerified\n    learner {\n      id\n      displayName\n      nativeLanguage\n      cefrLevel\n      picture {\n        preset\n        url\n      }\n      memories {\n        id\n        kind\n        text\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "37d1ba7816776abe0421f04f4ed5aa3e";

export default node;
